import { AbstractModel, DateConverter, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { CabinetReport } from 'projects/app-misc/src/app/modules/reports/data/cabinet-report';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@JsonObject('ReportLine')
export class ReportLine extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(Number, 'number')
  number?: number;

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Number, 'qty')
  qty: number;

  @JsonProperty(Number, 'price')
  price: number;

  @JsonProperty(Number, 'totalPrice')
  totalPrice: number;

  @JsonProperty(Boolean, 'editable')
  editable: boolean;
}


@JsonObject('OverallReport')
export class OverallReport extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty([ReportLine], 'items')
  items: ReportLine[];

  @JsonProperty(ShortProject, 'projectDTO')
  projectDTO: ShortProject;

  @JsonProperty(DateConverter, 'createdTime')
  createdTime: Date;

  @JsonProperty(Number, 'totalCost')
  totalCost: number;

  @JsonProperty(Number, 'estimatePrice')
  estimatePrice: number;
}

@JsonObject('OverallReportPage')
export class OverallReportPage extends ResponcePage {

  @JsonProperty([OverallReport], 'content')
  content: OverallReport[];
}
